/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Michael Diponio
 * Created: 02/05/2022
 */

import * as React from 'react';
import { Row, ValueCell } from '@/wpt-lib/pdf/common/Table';

const ProfessionalDevelopment = ({
    researchObjective,
    researchProposedDevOpportunity,
}: Partial<{
    researchObjective: string;
    researchProposedDevOpportunity: string;
}>) => (
    <>
        <Row>
            <ValueCell label="Proposed Development Activity" value={researchProposedDevOpportunity} />
        </Row>
        <Row>
            <ValueCell single label="Objective" value={researchObjective} />
        </Row>
    </>
);

export default ProfessionalDevelopment;
